"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const utils_1 = require("@samknows/utils");
const Emitter_1 = require("./Emitter");
const DeviceTesting_1 = tslib_1.__importDefault(require("./DeviceTesting"));
const InstantTest_const_1 = require("./InstantTest.const");
const UnitTriggerTesting_1 = tslib_1.__importDefault(require("./UnitTriggerTesting"));
const UnreachableCaseError_class_1 = require("./util/UnreachableCaseError.class");
const DEFAULT_TARGET = 'eero-global.samknows.com';
const PANEL_IDS = {
    COMPARATIVE_WEB: 231,
    SAMKNOWS_LAB_SANDBOX: 457
};
var TestType;
(function (TestType) {
    TestType["TWO_STEP"] = "Two Step";
    TestType["ONE_STEP_DEVICE"] = "One Step - Device Only";
    TestType["ONE_STEP_UNIT"] = "One Step - Unit Only";
})(TestType || (TestType = {}));
const InstantTest = {
    emit: Emitter_1.emitter.emit.bind(Emitter_1.emitter),
    on: Emitter_1.emitter.on.bind(Emitter_1.emitter),
    off: Emitter_1.emitter.off.bind(Emitter_1.emitter),
    testQueue: [],
    testsToRun: [],
    testType: TestType.ONE_STEP_UNIT,
    source: InstantTest_const_1.Source.REAL_SPEED_APP,
    results: [],
    unitId: null,
    device: null,
    panelId: null,
    agentId: null,
    apiUrls: null,
    targetSet: null,
    enableTestServer: false,
    useSandboxPanelId: false,
    getAgentId() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.agentId = yield this.registerWeb();
        });
    },
    init(options) {
        var _a, _b;
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.testQueue = [];
            this.source = (options === null || options === void 0 ? void 0 : options.source) || InstantTest_const_1.Source.REAL_SPEED_APP;
            this.testsToRun = (options === null || options === void 0 ? void 0 : options.testsToRun) || [
                {
                    test: InstantTest_const_1.UnitAvailableTests.DOWNLOAD,
                    type: InstantTest_const_1.InstantTestType.UNIT_TEST
                },
                {
                    test: InstantTest_const_1.DeviceAvailableTests.DOWNLOAD,
                    type: InstantTest_const_1.InstantTestType.DEVICE_TEST
                }
            ];
            this.unitId = options === null || options === void 0 ? void 0 : options.unit.id;
            this.device = options === null || options === void 0 ? void 0 : options.device;
            this.apiUrls = options === null || options === void 0 ? void 0 : options.apiUrls;
            this.targetSet = options === null || options === void 0 ? void 0 : options.targetSet;
            this.enableTestServer = !!(options === null || options === void 0 ? void 0 : options.enableTestServer);
            this.useSandboxPanelId = !!(options === null || options === void 0 ? void 0 : options.useSandboxPanelId);
            this.testType = this.getTestType(options === null || options === void 0 ? void 0 : options.isTwoStepTest, !!this.targetSet);
            utils_1.Tracking.addContext('testType', this.testType);
            this.panelId =
                this.testType === TestType.ONE_STEP_DEVICE
                    ? options === null || options === void 0 ? void 0 : options.panelId
                    : ((_b = (_a = options === null || options === void 0 ? void 0 : options.unit.panel) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.id) || PANEL_IDS.COMPARATIVE_WEB;
            this.getAgentId();
            this.results = [];
            this.initEventListeners();
            if (!options.unit && !options.panelId) {
                throw new Error('Missing unit and panelId; unit is required for 2step tests, panelId for 1step tests.');
            }
            // TODO move the below to `start` function.
            if (this.testType === TestType.ONE_STEP_DEVICE) {
                yield this.initDeviceTest();
            }
            else {
                // Two-step tests run Unit tests first, and then fetch the target server URLs from the unit config.
                // The Device tests are initialised from the configuration of the unit returned when the first Unit test starts posting results.
                UnitTriggerTesting_1.default.init(this.apiUrls.triggerTesting);
            }
        });
    },
    initEventListeners() {
        this.cancelEvents();
        // Emitted when the UnitTriggerTesting entity is ready to start
        Emitter_1.internalEmitter.on('instant-test:start-testing', () => {
            this.startTesting();
        });
        Emitter_1.internalEmitter.on('instant-test:results', ({ runningTest, result, status }) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.liveUpdateResults(runningTest, status, result);
            // Init web test after we get the first results to get the target
            if (this.testType === TestType.TWO_STEP && !(result === null || result === void 0 ? void 0 : result.error)) {
                yield this.initDeviceTest();
            }
        }));
        Emitter_1.internalEmitter.on('instant-test:ingest', () => tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.ingestResults();
        }));
        Emitter_1.internalEmitter.on('instant-test:cancel', () => {
            this.cancelTestQueue();
        });
        Emitter_1.internalEmitter.on('instant-test:test-finished', () => tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.handleTestFinished();
        }));
        Emitter_1.internalEmitter.on('instant-test:close-ws', () => {
            UnitTriggerTesting_1.default.disconnect();
        });
    },
    cancelEvents() {
        Emitter_1.internalEmitter.off('instant-test:start-testing');
        Emitter_1.internalEmitter.off('instant-test:results');
        Emitter_1.internalEmitter.off('instant-test:ingest');
        Emitter_1.internalEmitter.off('instant-test:cancel');
        Emitter_1.internalEmitter.off('instant-test:test-finished');
        Emitter_1.internalEmitter.off('instant-test:close-ws');
    },
    destroy() {
        this.cancelTestQueue();
        this.cancelEvents();
        UnitTriggerTesting_1.default.disconnect();
    },
    getTestType(isTwoStepTest, hasTargetSet) {
        if (isTwoStepTest) {
            return TestType.TWO_STEP;
        }
        if (hasTargetSet) {
            return TestType.ONE_STEP_DEVICE;
        }
        return TestType.ONE_STEP_UNIT;
    },
    getTarget() {
        var _a, _b, _c;
        const downloadResults = this.results.find((result) => {
            if (this.testType === TestType.ONE_STEP_DEVICE) {
                return result.task === InstantTest_const_1.DeviceAvailableTests.DOWNLOAD;
            }
            else {
                return includes([
                    InstantTest_const_1.UnitTestSchedulesTasks.UDP_DOWNLOAD,
                    InstantTest_const_1.UnitTestSchedulesTasks.HTTP_DOWNLOAD_MT
                ], result.task);
            }
        });
        return ((_b = (_a = downloadResults === null || downloadResults === void 0 ? void 0 : downloadResults.data) === null || _a === void 0 ? void 0 : _a.server_hostname) !== null && _b !== void 0 ? _b : (_c = downloadResults === null || downloadResults === void 0 ? void 0 : downloadResults.data) === null || _c === void 0 ? void 0 : _c.target);
    },
    getTestServer() {
        const urlParams = new URLSearchParams(window.location.search);
        if (this.enableTestServer && urlParams.has('testServer')) {
            return urlParams.get('testServer');
        }
        const target = this.getTarget();
        const testServer = target === InstantTest_const_1.CLOUDFLARE_SK_CDN ? DEFAULT_TARGET : target;
        return testServer;
    },
    getEnabledTestToRun() {
        let allowedTestTypes;
        switch (this.testType) {
            case TestType.TWO_STEP:
                allowedTestTypes = [
                    InstantTest_const_1.InstantTestType.DEVICE_TEST,
                    InstantTest_const_1.InstantTestType.UNIT_TEST
                ];
                break;
            case TestType.ONE_STEP_DEVICE:
                allowedTestTypes = [InstantTest_const_1.InstantTestType.DEVICE_TEST];
                break;
            case TestType.ONE_STEP_UNIT:
                allowedTestTypes = [InstantTest_const_1.InstantTestType.UNIT_TEST];
                break;
            default:
                throw new UnreachableCaseError_class_1.UnreachableCaseError(this.testType);
        }
        return this.testsToRun.filter((test) => allowedTestTypes.includes(test.type));
    },
    cancelTestQueue() {
        this.testQueue.splice(0, this.testQueue.length);
        this.results = this.results.filter((test) => test.status === InstantTest_const_1.TestStatus.FINISHED);
    },
    addInitialStatus(runningTest) {
        const updatedResults = this.results.slice();
        const testResult = updatedResults.find((result) => result.task === runningTest.task);
        testResult.status = InstantTest_const_1.TestStatus.REQUESTING;
        this.results = updatedResults;
        this.sendResults();
    },
    liveUpdateResults(runningTest, status, result) {
        const updatedResults = this.results.slice();
        const testResultIndex = updatedResults.findIndex((testResult) => testResult.task === runningTest.task);
        updatedResults[testResultIndex] = Object.assign(Object.assign({}, result), { status });
        this.results = updatedResults;
        this.sendResults();
    },
    sendResults() {
        const results = this.results.reduce((resultsObject, result) => {
            function getResultTypeFromTask(task) {
                switch (task) {
                    case InstantTest_const_1.UnitTestSchedulesTasks.UDP_DOWNLOAD: // falls through
                    case InstantTest_const_1.UnitTestSchedulesTasks.HTTP_DOWNLOAD_ST: // falls through
                    case InstantTest_const_1.UnitTestSchedulesTasks.HTTP_DOWNLOAD_MT:
                        return InstantTest_const_1.UnitAvailableTests.DOWNLOAD;
                    case InstantTest_const_1.UnitTestSchedulesTasks.UDP_UPLOAD: // falls through
                    case InstantTest_const_1.UnitTestSchedulesTasks.HTTP_UPLOAD_ST: // falls through
                    case InstantTest_const_1.UnitTestSchedulesTasks.HTTP_UPLOAD_MT:
                        return InstantTest_const_1.UnitAvailableTests.UPLOAD;
                    case InstantTest_const_1.UnitTestSchedulesTasks.UDP_JITTER:
                        return InstantTest_const_1.UnitAvailableTests.JITTER;
                    case InstantTest_const_1.DeviceAvailableTests.LATENCY:
                        return InstantTest_const_1.DeviceAvailableTests.LATENCY;
                    case InstantTest_const_1.DeviceAvailableTests.DOWNLOAD:
                        return InstantTest_const_1.DeviceAvailableTests.DOWNLOAD;
                    case InstantTest_const_1.DeviceAvailableTests.UPLOAD:
                        return InstantTest_const_1.DeviceAvailableTests.UPLOAD;
                    default:
                        throw new UnreachableCaseError_class_1.UnreachableCaseError(task);
                }
            }
            const resultName = getResultTypeFromTask(result.task);
            /* eslint-disable-next-line @typescript-eslint/no-explicit-any */ // This should absolutely not be necessary but the code is very complex and TS cannot infer the correct types
            resultsObject[resultName] = result;
            return resultsObject;
        }, {});
        Emitter_1.emitter.emit('results', results);
    },
    connect(accessToken) {
        if (accessToken && !utils_1.Http.accessToken) {
            utils_1.Http.accessToken = accessToken;
        }
        UnitTriggerTesting_1.default.connect({
            accessToken,
            unitId: this.unitId
        });
    },
    handleTestFinished() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.testQueue.shift();
            if (this.testQueue.length) {
                const test = this.testQueue[0];
                if (test.type === InstantTest_const_1.InstantTestType.DEVICE_TEST) {
                    // TODO CH-1319 we should not be waiting, fix web-sdk and then remove the setTimeout wrapper
                    setTimeout(() => {
                        // Wait a frame before running the next test to ensure that web-sdk has a chance to clean itself up (see CH-1319)
                        this.runDeviceTest(test);
                    });
                }
                else {
                    UnitTriggerTesting_1.default.runningTest(test);
                }
                return;
            }
            UnitTriggerTesting_1.default.disconnect();
            yield this.ingestResults();
        });
    },
    runDeviceTest(test) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const options = yield this.fetchTestOptions(test);
            DeviceTesting_1.default.runningTest(test, options);
        });
    },
    fetchTestOptions(test) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const MAP_TRIGGER_TEST_WEB_TEST = {
                [InstantTest_const_1.DeviceAvailableTests.DOWNLOAD]: InstantTest_const_1.UnitTestSchedulesTasks.HTTP_DOWNLOAD_MT,
                [InstantTest_const_1.DeviceAvailableTests.UPLOAD]: InstantTest_const_1.UnitTestSchedulesTasks.HTTP_UPLOAD_MT
            };
            const TEST_UNIT_TASK = MAP_TRIGGER_TEST_WEB_TEST[test.task];
            const testAction = this.results.find((result) => result.task === TEST_UNIT_TASK);
            try {
                const globalOptions = this.getDeviceTestOptions();
                let connections = undefined;
                let duration = undefined;
                if (includes([
                    InstantTest_const_1.UnitTestSchedulesTasks.HTTP_DOWNLOAD_MT,
                    InstantTest_const_1.UnitTestSchedulesTasks.HTTP_UPLOAD_MT
                ], testAction === null || testAction === void 0 ? void 0 : testAction.task)) {
                    const { data } = yield this.getLmapActionOptions(testAction.action_id);
                    connections = data.connections
                        ? parseInt(data.connections, 10)
                        : undefined;
                    duration = data.results_interval_period
                        ? parseInt(data.results_interval_period, 10) * 1000
                        : undefined;
                    return Object.assign(Object.assign({}, globalOptions), { wsConcurrency: connections, fetchConcurrency: connections, duration: duration });
                }
                else {
                    return globalOptions;
                }
            }
            catch (error) {
                console.error(error);
            }
        });
    },
    getLmapActionOptions(id) {
        return utils_1.Http.request(`${this.apiUrls.zeus}/lmap/action/${id}/options`);
    },
    ingestResults() {
        var _a;
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            // prettier-ignore
            const mapTestIngestKeys = {
                [InstantTest_const_1.UnitTestSchedulesTasks.HTTP_DOWNLOAD_ST]: InstantTest_const_1.IngestingKeys.UNIT_HTTP_DOWNLOAD,
                [InstantTest_const_1.UnitTestSchedulesTasks.HTTP_UPLOAD_ST]: InstantTest_const_1.IngestingKeys.UNIT_HTTP_UPLOAD,
                [InstantTest_const_1.UnitTestSchedulesTasks.HTTP_DOWNLOAD_MT]: InstantTest_const_1.IngestingKeys.UNIT_HTTP_DOWNLOAD,
                [InstantTest_const_1.UnitTestSchedulesTasks.HTTP_UPLOAD_MT]: InstantTest_const_1.IngestingKeys.UNIT_HTTP_UPLOAD,
                [InstantTest_const_1.UnitTestSchedulesTasks.UDP_JITTER]: InstantTest_const_1.IngestingKeys.UNIT_UDP_JITTER,
                [InstantTest_const_1.UnitTestSchedulesTasks.UDP_DOWNLOAD]: InstantTest_const_1.IngestingKeys.UNIT_UDP_DOWNLOAD,
                [InstantTest_const_1.UnitTestSchedulesTasks.UDP_UPLOAD]: InstantTest_const_1.IngestingKeys.UNIT_UDP_UPLOAD,
                [InstantTest_const_1.DeviceAvailableTests.DOWNLOAD]: InstantTest_const_1.IngestingKeys.DEVICE_WEB_DOWNLOAD,
                [InstantTest_const_1.DeviceAvailableTests.UPLOAD]: InstantTest_const_1.IngestingKeys.DEVICE_WEB_UPLOAD,
                [InstantTest_const_1.DeviceAvailableTests.LATENCY]: InstantTest_const_1.IngestingKeys.DEVICE_WEB_LATENCY
            };
            const tests = {};
            for (const test of this.results) {
                if (test.status !== InstantTest_const_1.TestStatus.FINISHED) {
                    return;
                }
                const ingestKey = mapTestIngestKeys[test.task];
                if (!test.ingested) {
                    const testData = Object.assign({}, test.data);
                    // the properties deleted below are required for the UI but should not be ingested
                    // casting to any because TS wants to type-check if they exist, but we don't care since we're just deleting them
                    /* eslint-disable @typescript-eslint/no-explicit-any */
                    delete testData.percentage_complete;
                    delete testData.dtime;
                    delete testData.test_type;
                    /* eslint-enable @typescript-eslint/no-explicit-any */
                    if (test.task === InstantTest_const_1.UnitTestSchedulesTasks.UDP_DOWNLOAD ||
                        test.task === InstantTest_const_1.UnitTestSchedulesTasks.UDP_UPLOAD) {
                        delete testData.bytes_sec;
                    }
                    tests[ingestKey] = Object.assign(Object.assign({}, testData), { unit_id: this.unitId });
                    test.ingested = true;
                }
            }
            const hasFinishedTesting = Object.keys(tests).length;
            if (!hasFinishedTesting) {
                return;
            }
            // Delete the unnecessary keys: temporal fix.
            if (tests.unit_jitter) {
                /* eslint-disable-next-line @typescript-eslint/no-explicit-any */ // casting to any because as far as I can see this never exists
                delete tests.unit_jitter.jitter;
                /* eslint-disable-next-line @typescript-eslint/no-explicit-any */ // casting to any because as far as I can see this never exists
                delete tests.unit_jitter.packet_loss;
            }
            utils_1.Tracking.sendGaEvent('Test', `Ingesting ${Object.keys(tests)}`);
            let deviceToIngest = {};
            if ((_a = this.device) === null || _a === void 0 ? void 0 : _a.isMobileDevice) {
                deviceToIngest = {
                    device_model: this.device.model,
                    device_name: this.device.name,
                    device_manufacturer: this.device.manufacturer
                };
            }
            const dataToIngest = {
                device_environment: Object.assign({ user_agent: navigator.userAgent, timezone_offset: new Date().getTimezoneOffset() * -1 }, deviceToIngest),
                tests
            };
            let testId = null;
            try {
                const response = yield this.ingestWeb(dataToIngest);
                testId = response === null || response === void 0 ? void 0 : response.test_id;
                Emitter_1.emitter.emit('tests-complete', testId);
            }
            catch (error) { }
            return testId;
        });
    },
    registerWeb() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const panelId = this.useSandboxPanelId
                ? PANEL_IDS.SAMKNOWS_LAB_SANDBOX
                : this.panelId;
            const prefAgent = `ingestion-agent-id-${panelId}`;
            const localAgentId = utils_1.prefStorage.get(prefAgent);
            if (localAgentId) {
                return Promise.resolve(localAgentId);
            }
            const response = yield utils_1.Http.request(`${this.apiUrls.ingestion}/register/web`, {
                method: 'POST',
                body: JSON.stringify({
                    panelId: panelId,
                    browserId: Math.round(Math.random() * 1e16).toString(16),
                    userAgent: navigator.userAgent
                })
            });
            const { agentId } = response;
            utils_1.prefStorage.set(prefAgent, agentId, true);
            return agentId;
        });
    },
    ingestWeb(body) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const agentId = this.agentId || (yield this.registerWeb());
            const url = `${this.apiUrls.ingestion}/ingest/web`;
            const options = {
                method: 'POST',
                body: JSON.stringify({
                    version: '1',
                    agentId,
                    source: this.source,
                    data: body
                })
            };
            return utils_1.Http.request(url, Object.assign({ useAuth: false }, options));
        });
    },
    updateTestQueue() {
        const actionsToRun = this.getEnabledTestToRun()
            .map((testToRun) => {
            const testType = testToRun.type;
            switch (testType) {
                case InstantTest_const_1.InstantTestType.UNIT_TEST:
                    return this.createUnitAction(testToRun);
                case InstantTest_const_1.InstantTestType.DEVICE_TEST:
                    return {
                        task: testToRun.test,
                        type: testType
                    };
                default:
                    throw new UnreachableCaseError_class_1.UnreachableCaseError(testType);
            }
        })
            .filter(Boolean) // Remove unsupported (null) actions
            .filter((action) => !!action.task);
        utils_1.Tracking.sendGaEvent('Test', `${this.source} triggered run`);
        actionsToRun.forEach((action) => {
            this.addTestToQueue(action);
        });
    },
    /**
     * Create an Action to run the given test.
     * @param testToRun Test definition for a Unit test
     * @returns Action configuration, or null if the action is unsupported by the unit.
     */
    createUnitAction(testToRun) {
        const isUdpUploadEnabled = !!UnitTriggerTesting_1.default.actions.find(({ task }) => task === InstantTest_const_1.UnitTestSchedulesTasks.UDP_UPLOAD);
        const isUdpDownloadEnabled = !!UnitTriggerTesting_1.default.actions.find(({ task }) => task === InstantTest_const_1.UnitTestSchedulesTasks.UDP_DOWNLOAD);
        const testName = testToRun.test;
        const requiredActionTask = {
            [InstantTest_const_1.UnitAvailableTests.UPLOAD]: isUdpUploadEnabled
                ? InstantTest_const_1.UnitTestSchedulesTasks.UDP_UPLOAD
                : InstantTest_const_1.UnitTestSchedulesTasks.HTTP_UPLOAD_MT,
            [InstantTest_const_1.UnitAvailableTests.DOWNLOAD]: isUdpDownloadEnabled
                ? InstantTest_const_1.UnitTestSchedulesTasks.UDP_DOWNLOAD
                : InstantTest_const_1.UnitTestSchedulesTasks.HTTP_DOWNLOAD_MT,
            [InstantTest_const_1.UnitAvailableTests.JITTER]: InstantTest_const_1.UnitTestSchedulesTasks.UDP_JITTER
        }[testName];
        const ttAction = UnitTriggerTesting_1.default.actions.find(({ task }) => task === requiredActionTask);
        if (!ttAction) {
            // Action is unsupported by the device (see CH-1254)
            return null;
        }
        const action = Object.assign(Object.assign({}, ttAction), { task: ttAction.task, type: testToRun.type });
        return action;
    },
    addTestToQueue(action) {
        const testExistInQueue = this.testQueue.find((test) => test.task === action.task);
        if (testExistInQueue) {
            return;
        }
        this.testQueue.push({
            actionId: action.id,
            task: action.task,
            type: action.type
        }); // Unfortunately we have to cast because TS is not recognising that the types don't overlap
        this.results.unshift({
            task: action.task,
            data: {},
            status: InstantTest_const_1.TestStatus.QUEUED,
            ingested: false
        });
    },
    startTesting() {
        this.updateTestQueue();
        const test = this.testQueue[0];
        if (!test) {
            return;
        }
        this.addInitialStatus(test);
        utils_1.Tracking.sendApmTransaction({
            transactionType: 'testing-log',
            error: 'START_TESTING',
            labels: {
                fistTest: JSON.stringify(test)
            }
        });
        if (test.type === InstantTest_const_1.InstantTestType.DEVICE_TEST) {
            this.runDeviceTest(test);
        }
        else {
            UnitTriggerTesting_1.default.runningTest(test);
        }
    },
    getDeviceTestOptions() {
        const config = this.targetSet
            ? {
                targetSet: this.targetSet
            }
            : {
                testServer: this.getTestServer()
            };
        return config;
    },
    initDeviceTest() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const isWebTestInitiated = !!DeviceTesting_1.default.webSpeedTest;
            if (isWebTestInitiated) {
                return;
            }
            utils_1.Tracking.sendApmTransaction({
                transactionType: 'testing-log',
                error: 'INIT_DEVICE_TEST'
            });
            const config = this.getDeviceTestOptions();
            yield DeviceTesting_1.default.init(config);
        });
    },
    isRunning(task) {
        if (!task) {
            return false;
        }
        return [
            InstantTest_const_1.TestStatus.IN_PROGRESS,
            InstantTest_const_1.TestStatus.STARTING,
            InstantTest_const_1.TestStatus.REQUESTING,
            InstantTest_const_1.TestStatus.QUEUED
        ].includes(task.status);
    }
};
/**
 * Helper function to allow correctly inferring type for Array.prototype.includes()
 * when all the values in {array} are a slightly different type to {value}
 *
 * @example
 * enum West { SOUTH_WEST, NORTH_WEST }
 * enum East { SOUTH_EAST, NORTH_EAST }
 * type EastOrWest = East | West;
 *
 * const southEast: East = East.SOUTH_EAST;
 *
 * [West.SOUTH_WEST, West.NORTH_WEST].includes(southEast)
 * Error: East is not assignable to West ------^
 *
 * // Works, southEast is correctly inferred as EastOrWest
 * includes([West.SOUTH_WEST, West.NORTH_WEST], southEast);
 *
 * @param array Array of values to check against
 * @param value Value to check inside array
 * @returns `array.includes(value)`
 */
function includes(array, value) {
    return array.includes(value);
}
exports.default = InstantTest;
//# sourceMappingURL=InstantTest.js.map